/* ==========================================================================
   DRIONA - RESPONSIVE SWATCHES               added 7 Sep 2026
   Pairs with assets/dj-swatch-select.css. Two jobs only:
     1) a short press animation when an option is tapped
     2) a one-off flash on the price when the variant price changes

   It adds no elements to the page, registers no scroll or resize handlers,
   and watches nothing globally - a single delegated click listener that
   returns immediately unless the click was inside the product buy box.
   No-op on any page without .djp-main.
   ========================================================================== */
(function () {
  'use strict';

  if (window.__djSwatchSelect) return;
  window.__djSwatchSelect = true;

  var OPTIONS = '.djp-chip, .djp-stone__opt, .djp-fam__opt, .djp-sw__opt';

  function main()     { return document.querySelector('.djp-main'); }
  function priceNow() { var m = main(); return m && m.querySelector('[data-djp-price-now]'); }
  function priceBox() { var m = main(); return m && m.querySelector('.djp-price'); }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    if (!main()) return;

    var last = priceNow() ? priceNow().textContent.trim() : '';

    function flashPrice() {
      var p = priceNow();
      if (!p) return;
      var value = p.textContent.trim();
      if (value === last) return;      /* price did not actually change */
      last = value;
      var box = priceBox();
      if (!box) return;
      box.classList.remove('djsw-flash');
      void box.offsetWidth;
      box.classList.add('djsw-flash');
      setTimeout(function () { box.classList.remove('djsw-flash'); }, 1000);
    }

    document.addEventListener('click', function (e) {
      var opt = e.target && e.target.closest ? e.target.closest(OPTIONS) : null;
      if (!opt || !opt.closest('.djp-main')) return;

      opt.classList.remove('djsw-tap');
      void opt.offsetWidth;
      opt.classList.add('djsw-tap');
      setTimeout(function () { opt.classList.remove('djsw-tap'); }, 400);

      /* the theme rewrites the price after its own handler runs */
      [120, 350, 700].forEach(function (ms) { setTimeout(flashPrice, ms); });
    }, true);
  });
})();
